import {createEffect, createEvent, createStore, sample} from 'effector';

import {logErrorFx} from '#logger';
import fetchPermissions, {PermissionsData} from '#mapper/permissions';

export const getPermissions = createEvent<string>();

export const $permissions = createStore<PermissionsData['permissions']>({});
export const $prefixPermissions = createStore<PermissionsData['prefixPermissions']>({});

export const getPermissionsFx = createEffect((authproxyHost: string) => fetchPermissions(authproxyHost));

sample({
    clock: getPermissions,
    target: getPermissionsFx,
});

sample({
    clock: getPermissionsFx.doneData,
    fn: data => data.permissions,
    target: $permissions,
});

sample({
    clock: getPermissionsFx.doneData,
    fn: data => data.prefixPermissions,
    target: $prefixPermissions,
});

sample({
    clock: getPermissionsFx.failData,
    fn: error => ({
        params: {
            message: 'Error loading permissions',
        },
        error,
    }),
    target: logErrorFx,
});
